var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',[_c('base-wrapper',{attrs:{"variant":"fullscreen"}},[_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('shared-notification-list',{attrs:{"notifications":_vm.notifications}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }